import React from "react";
import { Heading } from "../../atoms";
import { Section } from "../../molecules";
export function GradientTitleSection(param) {
    var children = param.children, enableLines = param.enableLines, className = param.className, headlinevariant = param.headlinevariant;
    var hVariant = headlinevariant || "h2";
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        backgroundColor: "offdefault",
        lines: enableLines ? "dark" : false,
        className: className,
        contentClassName: "py-11 md:py-13"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: hVariant,
        className: "bg-gradient-to-br from-fg-default to-brand-primary-base bg-clip-text text-transparent leading-normal md:text-7xl"
    }, children)));
}

//# sourceMappingURL=GradientTitleSection.js.map